import { apiErrorPayload, type CoachingTier } from './api';

/**
 * Reading a plan refusal. The server answers a gated route with a code and a
 * feature, never with member-facing words — `ProLock` owns the copy, and these
 * are how a screen recognises which lock to show.
 */

/** Did this request come back as "that is a Pro feature"? */
export function isProRequired(err: unknown): boolean {
  return apiErrorPayload(err)?.error === 'coaching_pro_required';
}

/** Did this request come back as "free members hold one goal"? */
export function isGoalLimit(err: unknown): boolean {
  return apiErrorPayload(err)?.error === 'coaching_goal_limit';
}

/** What the tiers are called until the entitlement (which carries the tenant's names) has loaded. */
export const DEFAULT_TIER_LABELS: Record<CoachingTier, string> = {
  free: 'Free',
  pro: 'Success Pro',
  elite: 'Success Elite',
};

/** The member's plan in one word, for a row or a badge. */
export function tierLabel(
  tier: CoachingTier,
  labels: Record<CoachingTier, string> = DEFAULT_TIER_LABELS,
): string {
  return tier === 'free' ? 'Free plan' : labels[tier];
}
